const VANITY_URL_KEYS = {
  VANITY_URL: () => ['vanity-url'],
  AVAILABILITY: (vanityUrl) => [...VANITY_URL_KEYS.VANITY_URL(), 'availability', vanityUrl],
};

export default VANITY_URL_KEYS;
